import "./index.css";

const CustomerSkeleton = () => {
  return (
    <div className='customer-skeleton-container'>
      {/* Header Section */}
      <div className='customer-skeleton-header'>
        <div className='customer-skeleton-search-row'>
          <div className='customer-skeleton-search-box'></div>
          <div className='customer-skeleton-dropdown'></div>
        </div>
        <div className='customer-skeleton-select-all'>
          <div className='customer-skeleton-checkbox'></div>
          <div className='customer-skeleton-select-text'></div>
        </div>
      </div>

      {/* Cards Grid */}
      <div className='customer-skeleton-grid'>
        {Array.from({ length: 8 }).map((_, index) => (
          <div key={index} className='customer-skeleton-card'>
            <div className='customer-skeleton-card-header'>
              <div className='customer-skeleton-checkbox-small'></div>
              <div className='customer-skeleton-badge'></div>
            </div>

            <div className='customer-skeleton-user-info'>
              <div className='customer-skeleton-name'></div>
              <div className='customer-skeleton-subtitle'></div>
            </div>

            <div className='customer-skeleton-details'>
              <div className='customer-skeleton-field'>
                <div className='customer-skeleton-label'></div>
                <div className='customer-skeleton-value'></div>
              </div>
              <div className='customer-skeleton-field'>
                <div className='customer-skeleton-label'></div>
                <div className='customer-skeleton-value'></div>
              </div>
              <div className='customer-skeleton-field'>
                <div className='customer-skeleton-label'></div>
                <div className='customer-skeleton-value'></div>
              </div>
              <div className='customer-skeleton-field'>
                <div className='customer-skeleton-label'></div>
                <div className='customer-skeleton-value'></div>
              </div>
            </div>

            <div className='customer-skeleton-footer'>
              <div className='customer-skeleton-status'></div>
              <div className='customer-skeleton-amount'></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerSkeleton;
